import React from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import {ModalShell} from "../ui/ModalShell";
import {DOW_OPTIONS} from "../constants";
import {ModalMode, SelectOption} from "../types";
import {filterOnlyDow, toDatePickerDow} from "../utils/date";
import {ScheduledSupplyTemplateDTO} from "../../../../models/ScheduledSupplyTemplateDTO";
import {BtnSpinner} from "../../../../components/fields/BtnSpinner";

export function ScheduledModal({
                                   mode,
                                   templateOptions,
                                   scheduledTemplateId,
                                   setScheduledTemplateId,
                                   selectedTemplate,
                                   scheduledDepartureDate,
                                   setScheduledDepartureDate,
                                   scheduledAcceptanceDate,
                                   setScheduledAcceptanceDate,
                                   windowStart,
                                   windowEnd,
                                   onClose,
                                   onSubmit,
                                   isSaving,
                                   selectMenuPortal,
                               }: {
    mode: ModalMode;

    templateOptions: SelectOption[];
    scheduledTemplateId: number | null;
    setScheduledTemplateId: (v: number | null) => void;

    selectedTemplate: ScheduledSupplyTemplateDTO | null;

    scheduledDepartureDate: Date | null;
    setScheduledDepartureDate: (d: Date | null) => void;

    scheduledAcceptanceDate: Date | null;
    setScheduledAcceptanceDate: (d: Date | null) => void;

    windowStart: Date;
    windowEnd: Date;

    onClose: () => void;
    onSubmit: (e: React.FormEvent) => void;
    isSaving: boolean;

    selectMenuPortal: any;
}) {
    const depAllowed = selectedTemplate ? toDatePickerDow(selectedTemplate.departureDow) : null;
    const accAllowed = selectedTemplate ? toDatePickerDow(selectedTemplate.acceptanceDow) : null;

    const depLabel = selectedTemplate
        ? DOW_OPTIONS.find((d) => d.value === String(selectedTemplate.departureDow))?.label
        : null;

    const accLabel = selectedTemplate
        ? DOW_OPTIONS.find((d) => d.value === String(selectedTemplate.acceptanceDow))?.label
        : null;

    return (
        <ModalShell onClose={onClose}>
            <h2 className="supplies-modal-title">
                {mode === "create" ? "Добавить планируемую (из шаблона)" : "Изменить даты"}
            </h2>

            <form className="supplies-form" onSubmit={onSubmit}>
                <div className="admin-field">
                    <div className="admin_title">Шаблон</div>

                    <div style={{fontSize: 12, opacity: 0.8, marginBottom: 6}}>
                        Сначала выберите шаблон. После выбора станет доступен календарь, и он покажет только корректные
                        дни недели.
                    </div>

                    <Select
                        {...selectMenuPortal}
                        options={templateOptions}
                        value={
                            scheduledTemplateId
                                ? {
                                    value: String(scheduledTemplateId),
                                    label:
                                        templateOptions.find((x) => x.value === String(scheduledTemplateId))?.label || "—",
                                }
                                : null
                        }
                        onChange={(v) => {
                            const nextId = v ? Number((v as any).value) : null;
                            setScheduledTemplateId(nextId);

                            if (mode === "create") {
                                setScheduledDepartureDate(null);
                                setScheduledAcceptanceDate(null);
                            }
                        }}
                        classNamePrefix="supplies-select"
                        placeholder="Выберите шаблон..."
                        isDisabled={mode === "edit"}
                    />
                </div>

                <div className="supplies-form-row">
                    <div className="admin-field supplies-form-col">
                        <div className="admin_title">Дата отправки</div>

                        <DatePicker
                            selected={scheduledDepartureDate}
                            onChange={(d: Date | null) => setScheduledDepartureDate(d as Date | null)}
                            dateFormat="dd.MM.yyyy"
                            className="admin-input"
                            placeholderText={selectedTemplate ? "Выберите дату" : "Сначала выберите шаблон"}
                            disabled={!selectedTemplate}
                            minDate={windowStart}
                            maxDate={windowEnd}
                            filterDate={(date) => (depAllowed == null ? false : filterOnlyDow(date, depAllowed))}
                            calendarStartDay={1}
                        />

                        {selectedTemplate && (
                            <div style={{fontSize: 12, opacity: 0.75, marginTop: 4}}>
                                Доступны только даты: <b>{depLabel}</b>
                            </div>
                        )}
                    </div>

                    <div className="admin-field supplies-form-col">
                        <div className="admin_title">Дата приёмки</div>

                        <DatePicker
                            selected={scheduledAcceptanceDate}
                            onChange={(d: Date | null) => setScheduledAcceptanceDate(d as Date | null)}
                            dateFormat="dd.MM.yyyy"
                            className="admin-input"
                            placeholderText={selectedTemplate ? "Выберите дату" : "Сначала выберите шаблон"}
                            disabled={!selectedTemplate}
                            maxDate={windowEnd}
                            filterDate={(date) => (accAllowed == null ? false : filterOnlyDow(date, accAllowed))}
                            calendarStartDay={1}
                        />

                        {selectedTemplate && (
                            <div style={{fontSize: 12, opacity: 0.75, marginTop: 4}}>
                                Доступны только даты: <b>{accLabel}</b>
                            </div>
                        )}
                    </div>
                </div>

                <div className="supplies-modal-actions">
                    <button
                        type="button"
                        className="admin-button-secondary admin-button-secondary--ghost"
                        onClick={onClose}
                        disabled={isSaving}
                    >
                        Отмена
                    </button>

                    <button type="submit" className="admin-button-primary" disabled={isSaving}>
                        {isSaving ? (
                            <BtnSpinner/>
                        ) : mode === "create" ? (
                            "Добавить"
                        ) : (
                            "Сохранить"
                        )}
                    </button>
                </div>
            </form>
        </ModalShell>
    );
}
